"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetInvestmentDetailsSchemaKeys = exports.assetInvestmentDetailsSchema = exports.AssetInvestmentDataRenderingConditions = void 0;
const zod_1 = require("zod");
const enums_1 = require("../schema/enums");
const utils_1 = require("../utils");
const cashFlowTable_1 = require("./cashFlowTable");
const renderingConditions_1 = require("./renderingConditions");
const loanInformation_1 = require("../schema/subschemas/loanInformation");
const investorSettings_1 = require("../schema/subschemas/investorSettings");
const documents_1 = require("../schema/subschemas/documents");
const descriptions_1 = require("../schema/subschemas/descriptions");
const ifBorrowedCapital = (asset) => Boolean(asset.loanInformation?.borrowedCapital);
const ifCalculateReturnOnEquity = (asset) => Boolean(asset.investorSettings?.calculateReturnOnEquity);
const ifMaturity = (asset) => Boolean(asset.investmentDetails?.maturity);
exports.AssetInvestmentDataRenderingConditions = {
    'loanInformation.borrowedCapitalText': ifBorrowedCapital,
    'loanInformation.currentInterestPerY': ifBorrowedCapital,
    'loanInformation.currentRepaymentPerY': ifBorrowedCapital,
    'loanInformation.originalLoanAmount': ifBorrowedCapital,
    'loanInformation.repaymentType': ifBorrowedCapital,
    'investorSettings.fixedObservationPeriodInY': ifCalculateReturnOnEquity,
    'investorSettings.returnOnEquityText': ifCalculateReturnOnEquity,
    'investorSettings.distributionYieldText': ifCalculateReturnOnEquity,
    'investorSettings.assetValueDevelopment': ifCalculateReturnOnEquity,
    'documents.scenarioCalculations': ifCalculateReturnOnEquity,
    'investorSettings.assetValueDevelopmentText': ifCalculateReturnOnEquity,
    'investmentDetails.cashFlowTable': ifCalculateReturnOnEquity,
    'investmentDetails.maturityDate': ifMaturity,
    'investmentDetails.maturityDateOnlyExpectedTerminationRight': ifMaturity,
};
exports.assetInvestmentDetailsSchema = zod_1.z.preprocess(utils_1.removeNullUndefined, zod_1.z
    .object({
    loanInformation: loanInformation_1.LoanInformation.pick({
        originalLoanAmount: true,
        currentInterestPerY: true,
        currentRepaymentPerY: true,
        repaymentType: true,
        borrowedCapitalText: true,
        borrowedCapital: true,
    }),
    investorSettings: investorSettings_1.InvestorSettings.pick({
        calculateReturnOnEquity: true,
        fixedObservationPeriodInY: true,
        returnOnEquityText: true,
        distributionYieldText: true,
        assetValueDevelopmentText: true,
        assetValueDevelopment: true,
    }),
    documents: documents_1.DocumentsValidationSchema.pick({
        investmentBasicInformation: true,
        investmentInformation: true,
        investmentConditions: true,
        scenarioCalculations: true,
        additionalInvestmentDocuments: true,
    }),
    descriptions: descriptions_1.DescriptionValidationSchema.pick({
        investmentDetails: true,
        investmentDetailsAddition: true,
        securityDetails: true,
        taxInformation: true,
        overview: true,
    }),
    // TODO: pick
    investmentDetails: zod_1.z
        .object({
        issueStartDate: zod_1.z.coerce.date(),
        issueEndDate: zod_1.z.coerce.date(),
        terminationRight: zod_1.z.nativeEnum(enums_1.TTerminationRight),
        terminationRightFrequency: zod_1.z.string().optional(),
        maturityDate: zod_1.z.coerce.date().optional(),
        spv: utils_1.mongoDBObjectIdSchema,
        ISIN: zod_1.z.string(),
        sharePrice: zod_1.z.number().min(1),
        totalBricks: zod_1.z.number().min(1),
        issueFundingFloor: zod_1.z.number(),
        minSubscriptionAmount: zod_1.z.number().max(100).default(0),
        maturity: utils_1.booleanField,
        securityType: zod_1.z.nativeEnum(enums_1.TSecurityType),
        repaymentAmount: zod_1.z.number().optional(),
        taxInfo: zod_1.z.string().optional(),
        estimatedRentIndexation: zod_1.z.number().optional(),
        cashFlowTable: zod_1.z.optional(cashFlowTable_1.CashFlowTable),
        cashFlowPerformance: zod_1.z.number().optional(),
        cashFlowTableStressScenario: zod_1.z.optional(cashFlowTable_1.CashFlowTable),
        cashFlowPerformanceStressScenario: zod_1.z.number().optional(),
        cashFlowTableOptimisticScenario: zod_1.z.optional(cashFlowTable_1.CashFlowTable),
        cashFlowPerformanceOptimisticScenario: zod_1.z.number().optional(),
        maturityDateOnlyExpectedTerminationRight: zod_1.z.boolean().optional(),
        forumActive: zod_1.z.boolean().optional(),
        totalConstructionVolume: zod_1.z.number(),
        totalConstructionVolumeNote: zod_1.z.string(),
        publicFunding: zod_1.z.number(),
        publicFundingNote: zod_1.z.string(),
        brokerageFeeForEndCustomers: zod_1.z.boolean(),
        accountName: zod_1.z.string(),
        iban: zod_1.z.string(),
        bic: zod_1.z.string(),
        companyName: zod_1.z.string(),
        companyDescription: zod_1.z.string(),
        yield: zod_1.z.number(),
        yieldIntroductoryText: zod_1.z.string(),
        yieldFieldname: zod_1.z.string(),
        yieldInfoIcon: zod_1.z.string(),
    })
        .partial(),
})
    .partial()
    .transform((data) => {
    (0, renderingConditions_1.postProcessAsset)(exports.AssetInvestmentDataRenderingConditions)(data);
    return data;
}));
exports.assetInvestmentDetailsSchemaKeys = (0, utils_1.getZodSchemaKeys)(exports.assetInvestmentDetailsSchema);
//# sourceMappingURL=investmentData.js.map